(() => {
  'use strict';

  const replacement = '6–8 weeks';
  const turnaroundPattern = /(?:2[–-]4|4[–-]6) weeks/g;
  const hasOldTurnaround = /(?:2[–-]4|4[–-]6) weeks/;
  const skippedTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA']);

  const updateTurnaroundText = (root) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const matches = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      const parent = node.parentElement;
      if (!parent || skippedTags.has(parent.tagName)) continue;
      if (node.nodeValue && hasOldTurnaround.test(node.nodeValue)) matches.push(node);
    }
    matches.forEach((node) => {
      node.nodeValue = node.nodeValue.replace(turnaroundPattern, replacement);
    });
  };

  const run = () => updateTurnaroundText(document.body);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  window.addEventListener('sassy:core-ready', run);
  document.addEventListener('shopify:section:load', (event) => updateTurnaroundText(event.target));
})();
